'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareSubmission = exports.processFields = exports.reverseJsonPaths = exports.callbackEvaluateCondition = exports.evaluateCondition = undefined;

var _evaluateCondition = require('./evaluateCondition');

var _evaluateCondition2 = _interopRequireDefault(_evaluateCondition);

var _reverseJsonPaths2 = require('./reverseJsonPaths');

var _reverseJsonPaths3 = _interopRequireDefault(_reverseJsonPaths2);

var _getField = require('./getField');

var _getField2 = _interopRequireDefault(_getField);

var _getArrayMemberKey = require('./getArrayMemberKey');

var _getArrayMemberKey2 = _interopRequireDefault(_getArrayMemberKey);

var _processFields2 = require('./processFields');

var _processFields3 = _interopRequireDefault(_processFields2);

var _prepareSubmission2 = require('./prepareSubmission');

var _prepareSubmission3 = _interopRequireDefault(_prepareSubmission2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var evaluateCondition = exports.evaluateCondition = function evaluateCondition(condition, fields, jsonPaths, memberIndex) {
  return (0, _evaluateCondition2.default)(condition, function (varValue) {
    var key = memberIndex == null ? (0, _reverseJsonPaths3.default)(jsonPaths)[varValue] : (0, _getArrayMemberKey2.default)((0, _reverseJsonPaths3.default)(jsonPaths)[varValue], memberIndex);

    if (!key) return;

    return ((0, _getField2.default)(fields, key) || {}).value;
  });
};
exports.callbackEvaluateCondition = _evaluateCondition2.default;
exports.reverseJsonPaths = _reverseJsonPaths3.default;
exports.processFields = _processFields3.default;
exports.prepareSubmission = _prepareSubmission3.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-metadata-2/dist/index.js
// module id = 225
// module chunks = 0